var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 93,
    viewBox: "0 0 300 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1166_401",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 90,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0592 43.367H12.0539L3.02391 20.2868C2.3247 18.388 2.09447 16.3484 2.35282 14.3416C2.61117 12.3347 3.35045 10.4199 4.50777 8.76017C5.66509 7.1004 7.20619 5.74473 8.99999 4.80849C10.7938 3.87226 12.7872 3.38316 14.8106 3.38281H83.2671C84.7932 3.38594 86.289 3.80881 87.5908 4.60512C88.8926 5.40144 89.9503 6.54053 90.6481 7.89771C91.3459 9.2549 91.6569 10.7779 91.5471 12.3C91.4373 13.8221 90.9109 15.2847 90.0255 16.5276L74.8758 37.7889C73.6479 39.5134 72.0255 40.9194 70.144 41.8897C68.2624 42.86 66.1762 43.3665 64.0592 43.367Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1166_401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11302 3.38281H2.23828V43.367H7.11302V3.38281Z",
    fill: "#2B5C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9802 3.38281H7.10547V43.367H11.9802V3.38281Z",
    fill: "#2A5C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8552 3.38281H11.9805V43.367H16.8552V3.38281Z",
    fill: "#295D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7302 3.38281H16.8555V43.367H21.7302V3.38281Z",
    fill: "#285D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5974 3.38281H21.7227V43.367H26.5974V3.38281Z",
    fill: "#275D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4724 3.38281H26.5977V43.367H31.4724V3.38281Z",
    fill: "#265E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3474 3.38281H31.4727V43.367H36.3474V3.38281Z",
    fill: "#255E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2146 3.38281H36.3398V43.367H41.2146V3.38281Z",
    fill: "#235E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0896 3.38281H41.2148V43.367H46.0896V3.38281Z",
    fill: "#225F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9529 3.38281H46.0781V43.367H50.9529V3.38281Z",
    fill: "#215F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8279 3.38281H50.9531V43.367H55.8279V3.38281Z",
    fill: "#205F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7029 3.38281H55.8281V43.367H60.7029V3.38281Z",
    fill: "#1F607A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5701 3.38281H60.6953V43.367H65.5701V3.38281Z",
    fill: "#1E607A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8613 3.38281H65.5703V43.367H65.8613V3.38281Z",
    fill: "#1E607A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1543 3.38281H65.8633V43.367H66.1543V3.38281Z",
    fill: "#1E617B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4434 3.38281H66.1523V43.367H66.4434V3.38281Z",
    fill: "#1F627C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7246 3.38281H66.4336V43.367H66.7246V3.38281Z",
    fill: "#1F637D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0176 3.38281H66.7266V43.367H67.0176V3.38281Z",
    fill: "#20647E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3067 3.38281H67.0156V43.367H67.3067V3.38281Z",
    fill: "#20647F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5996 3.38281H67.3086V43.367H67.5996V3.38281Z",
    fill: "#216580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8809 3.38281H67.5898V43.367H67.8809V3.38281Z",
    fill: "#216681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1738 3.38281H67.8828V43.367H68.1738V3.38281Z",
    fill: "#216782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4629 3.38281H68.1719V43.367H68.4629V3.38281Z",
    fill: "#226883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7559 3.38281H68.4648V43.367H68.7559V3.38281Z",
    fill: "#226984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0371 3.38281H68.7461V43.367H69.0371V3.38281Z",
    fill: "#236A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3301 3.38281H69.0391V43.367H69.3301V3.38281Z",
    fill: "#236B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6192 3.38281H69.3281V43.367H69.6192V3.38281Z",
    fill: "#246B87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9043 3.38281H69.6133V43.367H69.9043V3.38281Z",
    fill: "#246C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1934 3.38281H69.9023V43.367H70.1934V3.38281Z",
    fill: "#246D89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4863 3.38281H70.1953V43.367H70.4863V3.38281Z",
    fill: "#256E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7754 3.38281H70.4844V43.367H70.7754V3.38281Z",
    fill: "#256F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0606 3.38281H70.7695V43.367H71.0606V3.38281Z",
    fill: "#26708C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3496 3.38281H71.0586V43.367H71.3496V3.38281Z",
    fill: "#26718D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6426 3.38281H71.3516V43.367H71.6426V3.38281Z",
    fill: "#27728E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9317 3.38281H71.6406V43.367H71.9317V3.38281Z",
    fill: "#27728F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2168 3.38281H71.9258V43.367H72.2168V3.38281Z",
    fill: "#277390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5059 3.38281H72.2148V43.367H72.5059V3.38281Z",
    fill: "#287491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7988 3.38281H72.5078V43.367H72.7988V3.38281Z",
    fill: "#287592"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0879 3.38281H72.7969V43.367H73.0879V3.38281Z",
    fill: "#297693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3731 3.38281H73.082V43.367H73.3731V3.38281Z",
    fill: "#297794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6621 3.38281H73.3711V43.367H73.6621V3.38281Z",
    fill: "#2A7895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9551 3.38281H73.6641V43.367H73.9551V3.38281Z",
    fill: "#2A7996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2441 3.38281H73.9531V43.367H74.2441V3.38281Z",
    fill: "#2A7997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5293 3.38281H74.2383V43.367H74.5293V3.38281Z",
    fill: "#2B7A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8184 3.38281H74.5273V43.367H74.8184V3.38281Z",
    fill: "#2B7B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1113 3.38281H74.8203V43.367H75.1113V3.38281Z",
    fill: "#2C7C9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4004 3.38281H75.1094V43.367H75.4004V3.38281Z",
    fill: "#2C7D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6856 3.38281H75.3945V43.367H75.6856V3.38281Z",
    fill: "#2D7E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9746 3.38281H75.6836V43.367H75.9746V3.38281Z",
    fill: "#2D7F9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2676 3.38281H75.9766V43.367H76.2676V3.38281Z",
    fill: "#2D809E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5567 3.38281H76.2656V43.367H76.5567V3.38281Z",
    fill: "#2E809F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8379 3.38281H76.5469V43.367H76.8379V3.38281Z",
    fill: "#2E81A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1309 3.38281H76.8398V43.367H77.1309V3.38281Z",
    fill: "#2F82A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4199 3.38281H77.1289V43.367H77.4199V3.38281Z",
    fill: "#2F83A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7129 3.38281H77.4219V43.367H77.7129V3.38281Z",
    fill: "#3084A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9942 3.38281H77.7031V43.367H77.9942V3.38281Z",
    fill: "#3085A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2871 3.38281H77.9961V43.367H78.2871V3.38281Z",
    fill: "#3086A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5762 3.38281H78.2852V43.367H78.5762V3.38281Z",
    fill: "#3187A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8692 3.38281H78.5781V43.367H78.8692V3.38281Z",
    fill: "#3187A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1504 3.38281H78.8594V43.367H79.1504V3.38281Z",
    fill: "#3288A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4434 3.38281H79.1523V43.367H79.4434V3.38281Z",
    fill: "#3289AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7324 3.38281H79.4414V43.367H79.7324V3.38281Z",
    fill: "#328AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0254 3.38281H79.7344V43.367H80.0254V3.38281Z",
    fill: "#338BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3066 3.38281H80.0156V43.367H80.3066V3.38281Z",
    fill: "#338CAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5996 3.38281H80.3086V43.367H80.5996V3.38281Z",
    fill: "#348DAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8887 3.38281H80.5977V43.367H80.8887V3.38281Z",
    fill: "#348EAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1817 3.38281H80.8906V43.367H81.1817V3.38281Z",
    fill: "#358EB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4629 3.38281H81.1719V43.367H81.4629V3.38281Z",
    fill: "#358FB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7559 3.38281H81.4648V43.367H81.7559V3.38281Z",
    fill: "#3590B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0449 3.38281H81.7539V43.367H82.0449V3.38281Z",
    fill: "#3691B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3379 3.38281H82.0469V43.367H82.3379V3.38281Z",
    fill: "#3692B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6192 3.38281H82.3281V43.367H82.6192V3.38281Z",
    fill: "#3793B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9121 3.38281H82.6211V43.367H82.9121V3.38281Z",
    fill: "#3794B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2012 3.38281H82.9102V43.367H83.2012V3.38281Z",
    fill: "#3895B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4942 3.38281H83.2031V43.367H83.4942V3.38281Z",
    fill: "#3895B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7754 3.38281H83.4844V43.367H83.7754V3.38281Z",
    fill: "#3896B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0684 3.38281H83.7773V43.367H84.0684V3.38281Z",
    fill: "#3997BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3574 3.38281H84.0664V43.367H84.3574V3.38281Z",
    fill: "#3998BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6504 3.38281H84.3594V43.367H84.6504V3.38281Z",
    fill: "#3A99BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9317 3.38281H84.6406V43.367H84.9317V3.38281Z",
    fill: "#3A9ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2246 3.38281H84.9336V43.367H85.2246V3.38281Z",
    fill: "#3B9BBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5137 3.38281H85.2227V43.367H85.5137V3.38281Z",
    fill: "#3B9CBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8067 3.38281H85.5156V43.367H85.8067V3.38281Z",
    fill: "#3B9CC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0879 3.38281H85.7969V43.367H86.0879V3.38281Z",
    fill: "#3C9DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3809 3.38281H86.0898V43.367H86.3809V3.38281Z",
    fill: "#3C9EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6699 3.38281H86.3789V43.367H86.6699V3.38281Z",
    fill: "#3D9FC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9629 3.38281H86.6719V43.367H86.9629V3.38281Z",
    fill: "#3DA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2442 3.38281H86.9531V43.367H87.2442V3.38281Z",
    fill: "#3EA1C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5332 3.38281H87.2422V43.367H87.5332V3.38281Z",
    fill: "#3EA2C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8262 3.38281H87.5352V43.367H87.8262V3.38281Z",
    fill: "#3EA3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1152 3.38281H87.8242V43.367H88.1152V3.38281Z",
    fill: "#3FA3C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4004 3.38281H88.1094V43.367H88.4004V3.38281Z",
    fill: "#3FA4C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6895 3.38281H88.3984V43.367H88.6895V3.38281Z",
    fill: "#40A5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9824 3.38281H88.6914V43.367H88.9824V3.38281Z",
    fill: "#40A6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2637 3.38281H88.9727V43.367H89.2637V3.38281Z",
    fill: "#41A7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5567 3.38281H89.2656V43.367H89.5567V3.38281Z",
    fill: "#41A8CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8457 3.38281H89.5547V43.367H89.8457V3.38281Z",
    fill: "#41A9CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1387 3.38281H89.8477V43.367H90.1387V3.38281Z",
    fill: "#42AACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4199 3.38281H90.1289V43.367H90.4199V3.38281Z",
    fill: "#42AAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7129 3.38281H90.4219V43.367H90.7129V3.38281Z",
    fill: "#43ABD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.002 3.38281H90.7109V43.367H91.002V3.38281Z",
    fill: "#43ACD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2949 3.38281H91.0039V43.367H91.2949V3.38281Z",
    fill: "#44ADD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5762 3.38281H91.2852V43.367H91.5762V3.38281Z",
    fill: "#44AED4"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1166_401",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 58,
    height: 87
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0953 65.6469L41.142 85.9219C40.3481 87.075 39.2541 87.9891 37.9783 88.5654C36.7024 89.1418 35.2934 89.3584 33.9033 89.1919C32.5133 89.0255 31.1952 88.4822 30.0916 87.6209C28.9879 86.7596 28.1407 85.613 27.6415 84.3051L3.02528 20.2868C2.33465 18.4013 2.10541 16.378 2.35673 14.3858C2.60805 12.3937 3.33263 10.4906 4.46988 8.83581C5.60713 7.18097 7.12401 5.82244 8.89371 4.87377C10.6634 3.9251 12.6345 3.41387 14.6422 3.38281H59.0161C56.6688 3.81969 54.3661 4.46909 52.1365 5.32301C46.6473 7.53806 43.8664 14.5147 45.8793 20.1089L56.987 51.0469C57.8497 53.4565 58.1281 56.0365 57.7992 58.5747C57.4704 61.1129 56.5436 63.5368 55.0953 65.6469Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1166_401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 3.38281H0.0273438V5.81614H59.0416V3.38281Z",
    fill: "#53A1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 5.81641H0.0273438V8.24973H59.0416V5.81641Z",
    fill: "#53A2D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 8.25H0.0273438V10.6833H59.0416V8.25Z",
    fill: "#52A3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 10.6914H0.0273438V13.1247H59.0416V10.6914Z",
    fill: "#52A4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 13.125H0.0273438V15.5583H59.0416V13.125Z",
    fill: "#52A5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 15.5586H0.0273438V17.9919H59.0416V15.5586Z",
    fill: "#52A6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 17.9922H0.0273438V20.4255H59.0416V17.9922Z",
    fill: "#51A7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 20.4258H0.0273438V22.8591H59.0416V20.4258Z",
    fill: "#51A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 22.8594H0.0273438V25.2927H59.0416V22.8594Z",
    fill: "#51A9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 25.3008H0.0273438V27.7341H59.0416V25.3008Z",
    fill: "#50AADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 27.7305H0.0273438V30.1638H59.0416V27.7305Z",
    fill: "#50ABE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 30.1641H0.0273438V32.5974H59.0416V30.1641Z",
    fill: "#50ACE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 32.5977H0.0273438V35.031H59.0416V32.5977Z",
    fill: "#50AEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 35.0312H0.0273438V37.4646H59.0416V35.0312Z",
    fill: "#4FAFE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 37.4648H0.0273438V39.8982H59.0416V37.4648Z",
    fill: "#4FB0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 39.9062H0.0273438V42.3396H59.0416V39.9062Z",
    fill: "#4FB1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 42.3398H0.0273438V44.7732H59.0416V42.3398Z",
    fill: "#4EB2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 44.7734H0.0273438V47.2068H59.0416V44.7734Z",
    fill: "#4EB3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 47.207H0.0273438V49.6404H59.0416V47.207Z",
    fill: "#4EB4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 49.6406H0.0273438V52.074H59.0416V49.6406Z",
    fill: "#4DB5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 52.082H0.0273438V54.5154H59.0416V52.082Z",
    fill: "#4DB6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 54.5156H0.0273438V56.949H59.0416V54.5156Z",
    fill: "#4DB7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 56.9492H0.0273438V59.3825H59.0416V56.9492Z",
    fill: "#4DB8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 59.3828H0.0273438V61.8161H59.0416V59.3828Z",
    fill: "#4CB9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 61.8164H0.0273438V64.2497H59.0416V61.8164Z",
    fill: "#4CBAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 64.25H0.0273438V64.5249H59.0416V64.25Z",
    fill: "#4CBAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 64.5234H0.0273438V64.7983H59.0416V64.5234Z",
    fill: "#4DBAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 64.7969H0.0273438V65.0717H59.0416V64.7969Z",
    fill: "#4EBAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 65.0742H0.0273438V65.3491H59.0416V65.0742Z",
    fill: "#4FBAE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 65.3477H0.0273438V65.6225H59.0416V65.3477Z",
    fill: "#50BBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 65.6211H0.0273438V65.896H59.0416V65.6211Z",
    fill: "#51BBE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 65.8984H0.0273438V66.1733H59.0416V65.8984Z",
    fill: "#52BBE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 66.1719H0.0273438V66.4467H59.0416V66.1719Z",
    fill: "#53BBE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 66.4453H0.0273438V66.7202H59.0416V66.4453Z",
    fill: "#54BBE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 66.7227H0.0273438V66.9975H59.0416V66.7227Z",
    fill: "#55BBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 66.9961H0.0273438V67.271H59.0416V66.9961Z",
    fill: "#56BCE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 67.2734H0.0273438V67.5483H59.0416V67.2734Z",
    fill: "#57BCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 67.5469H0.0273438V67.8217H59.0416V67.5469Z",
    fill: "#58BCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 67.8203H0.0273438V68.0952H59.0416V67.8203Z",
    fill: "#59BCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 68.0977H0.0273438V68.3725H59.0416V68.0977Z",
    fill: "#5ABCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 68.3711H0.0273438V68.646H59.0416V68.3711Z",
    fill: "#5BBCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 68.6445H0.0273438V68.9194H59.0416V68.6445Z",
    fill: "#5CBCDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 68.9219H0.0273438V69.1967H59.0416V68.9219Z",
    fill: "#5DBDDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 69.1953H0.0273438V69.4702H59.0416V69.1953Z",
    fill: "#5EBDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 69.4688H0.0273438V69.7436H59.0416V69.4688Z",
    fill: "#5FBDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 69.7461H0.0273438V70.021H59.0416V69.7461Z",
    fill: "#60BDDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 70.0195H0.0273438V70.2944H59.0416V70.0195Z",
    fill: "#61BDD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 70.2969H0.0273438V70.5717H59.0416V70.2969Z",
    fill: "#62BDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 70.5703H0.0273438V70.8452H59.0416V70.5703Z",
    fill: "#63BED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 70.8438H0.0273438V71.1186H59.0416V70.8438Z",
    fill: "#64BED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 71.1211H0.0273438V71.396H59.0416V71.1211Z",
    fill: "#65BED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 71.3945H0.0273438V71.6694H59.0416V71.3945Z",
    fill: "#66BED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 71.668H0.0273438V71.9428H59.0416V71.668Z",
    fill: "#67BED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 71.9453H0.0273438V72.2202H59.0416V71.9453Z",
    fill: "#68BED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 72.2188H0.0273438V72.4936H59.0416V72.2188Z",
    fill: "#69BFD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 72.4961H0.0273438V72.771H59.0416V72.4961Z",
    fill: "#6ABFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 72.7695H0.0273438V73.0444H59.0416V72.7695Z",
    fill: "#6BBFD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 73.043H0.0273438V73.3178H59.0416V73.043Z",
    fill: "#6CBFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 73.3203H0.0273438V73.5952H59.0416V73.3203Z",
    fill: "#6DBFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 73.5938H0.0273438V73.8686H59.0416V73.5938Z",
    fill: "#6EBFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 73.8672H0.0273438V74.142H59.0416V73.8672Z",
    fill: "#6FBFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 74.1445H0.0273438V74.4194H59.0416V74.1445Z",
    fill: "#70C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 74.418H0.0273438V74.6928H59.0416V74.418Z",
    fill: "#71C0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 74.6914H0.0273438V74.9663H59.0416V74.6914Z",
    fill: "#72C0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 74.9688H0.0273438V75.2436H59.0416V74.9688Z",
    fill: "#73C0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 75.2422H0.0273438V75.5171H59.0416V75.2422Z",
    fill: "#74C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 75.5195H0.0273438V75.7944H59.0416V75.5195Z",
    fill: "#75C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 75.793H0.0273438V76.0678H59.0416V75.793Z",
    fill: "#76C1C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 76.0586H0.0273438V76.3335H59.0416V76.0586Z",
    fill: "#77C1C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 76.3359H0.0273438V76.6108H59.0416V76.3359Z",
    fill: "#78C1C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 76.6094H0.0273438V76.8842H59.0416V76.6094Z",
    fill: "#7AC1C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 76.8828H0.0273438V77.1577H59.0416V76.8828Z",
    fill: "#7BC1C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 77.1602H0.0273438V77.435H59.0416V77.1602Z",
    fill: "#7CC1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 77.4336H0.0273438V77.7085H59.0416V77.4336Z",
    fill: "#7DC1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 77.707H0.0273438V77.9819H59.0416V77.707Z",
    fill: "#7EC2C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 77.9844H0.0273438V78.2592H59.0416V77.9844Z",
    fill: "#7FC2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 78.2578H0.0273438V78.5327H59.0416V78.2578Z",
    fill: "#80C2BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 78.5312H0.0273438V78.8061H59.0416V78.5312Z",
    fill: "#81C2BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 78.8086H0.0273438V79.0835H59.0416V78.8086Z",
    fill: "#82C2BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 79.082H0.0273438V79.3569H59.0416V79.082Z",
    fill: "#83C2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 79.3594H0.0273438V79.6342H59.0416V79.3594Z",
    fill: "#84C3BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 79.6328H0.0273438V79.9077H59.0416V79.6328Z",
    fill: "#85C3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 79.9062H0.0273438V80.1811H59.0416V79.9062Z",
    fill: "#86C3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 80.1836H0.0273438V80.4585H59.0416V80.1836Z",
    fill: "#87C3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 80.457H0.0273438V80.7319H59.0416V80.457Z",
    fill: "#88C3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 80.7305H0.0273438V81.0053H59.0416V80.7305Z",
    fill: "#89C3B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 81.0078H0.0273438V81.2827H59.0416V81.0078Z",
    fill: "#8AC3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 81.2812H0.0273438V81.5561H59.0416V81.2812Z",
    fill: "#8BC4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 81.5547H0.0273438V81.8295H59.0416V81.5547Z",
    fill: "#8CC4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 81.832H0.0273438V82.1069H59.0416V81.832Z",
    fill: "#8DC4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 82.1055H0.0273438V82.3803H59.0416V82.1055Z",
    fill: "#8EC4B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 82.3828H0.0273438V82.6577H59.0416V82.3828Z",
    fill: "#8FC4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 82.6562H0.0273438V82.9311H59.0416V82.6562Z",
    fill: "#90C4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 82.9297H0.0273438V83.2046H59.0416V82.9297Z",
    fill: "#91C5B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 83.207H0.0273438V83.4819H59.0416V83.207Z",
    fill: "#92C5AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 83.4805H0.0273438V83.7553H59.0416V83.4805Z",
    fill: "#93C5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 83.7539H0.0273438V84.0288H59.0416V83.7539Z",
    fill: "#94C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 84.0312H0.0273438V84.3061H59.0416V84.0312Z",
    fill: "#95C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 84.3047H0.0273438V84.5796H59.0416V84.3047Z",
    fill: "#96C5AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 84.5781H0.0273438V84.853H59.0416V84.5781Z",
    fill: "#97C6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 84.8555H0.0273438V85.1303H59.0416V84.8555Z",
    fill: "#98C6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 85.1289H0.0273438V85.4038H59.0416V85.1289Z",
    fill: "#99C6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 85.4062H0.0273438V85.6811H59.0416V85.4062Z",
    fill: "#9AC6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 85.6797H0.0273438V85.9545H59.0416V85.6797Z",
    fill: "#9BC6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 85.9531H0.0273438V86.228H59.0416V85.9531Z",
    fill: "#9CC6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 86.2305H0.0273438V86.5053H59.0416V86.2305Z",
    fill: "#9DC6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 86.5039H0.0273438V86.7788H59.0416V86.5039Z",
    fill: "#9EC7A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 86.7773H0.0273438V87.0522H59.0416V86.7773Z",
    fill: "#9FC7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 87.0547H0.0273438V87.3296H59.0416V87.0547Z",
    fill: "#A0C7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 87.3281H0.0273438V87.603H59.0416V87.3281Z",
    fill: "#A1C7A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 87.6016H0.0273438V87.8764H59.0416V87.6016Z",
    fill: "#A2C7A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 87.8789H0.0273438V88.1538H59.0416V87.8789Z",
    fill: "#A3C7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 88.1523H0.0273438V88.4272H59.0416V88.1523Z",
    fill: "#A4C8A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 88.4219H0.0273438V88.6967H59.0416V88.4219Z",
    fill: "#A5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 88.6953H0.0273438V88.9702H59.0416V88.6953Z",
    fill: "#A6C89E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 88.9688H0.0273438V89.2436H59.0416V88.9688Z",
    fill: "#A7C89D"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0524 23.0267C66.7759 23.0267 68.9838 20.8189 68.9838 18.0954C68.9838 15.3719 66.7759 13.1641 64.0524 13.1641C61.3289 13.1641 59.1211 15.3719 59.1211 18.0954C59.1211 20.8189 61.3289 23.0267 64.0524 23.0267Z",
    fill: "#E9E9E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M293.532 67.6609C290.158 67.6609 287.738 66.6893 286.272 64.7459C284.842 62.8026 284.127 60.2543 284.127 57.1009V46.0459H280.387V40.0509L284.567 39.7209L285.502 32.4609H292.212V39.7209H298.757V46.0459H292.212V56.9909C292.212 58.5309 292.523 59.6493 293.147 60.3459C293.807 61.0059 294.668 61.3359 295.732 61.3359C296.172 61.3359 296.612 61.2809 297.052 61.1709C297.528 61.0609 297.95 60.9326 298.317 60.7859L299.582 66.6709C298.885 66.8909 298.023 67.1109 296.997 67.3309C296.007 67.5509 294.852 67.6609 293.532 67.6609Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261.113 66.9986V39.7186H267.713L268.263 44.5036H268.483C269.473 42.6703 270.665 41.3136 272.058 40.4336C273.452 39.5169 274.845 39.0586 276.238 39.0586C277.008 39.0586 277.65 39.1136 278.163 39.2236C278.677 39.2969 279.117 39.4253 279.483 39.6086L278.163 46.5936C277.687 46.4469 277.21 46.3369 276.733 46.2636C276.293 46.1903 275.78 46.1536 275.193 46.1536C274.167 46.1536 273.085 46.5386 271.948 47.3086C270.848 48.0419 269.932 49.3253 269.198 51.1586V66.9986H261.113Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.322 67.6586C240.012 67.6586 237.83 67.1086 235.777 66.0086C233.76 64.8719 232.128 63.2403 230.882 61.1136C229.635 58.9503 229.012 56.3653 229.012 53.3586C229.012 50.3153 229.635 47.7303 230.882 45.6036C232.128 43.4769 233.76 41.8636 235.777 40.7636C237.83 39.6269 240.012 39.0586 242.322 39.0586C244.632 39.0586 246.795 39.6269 248.812 40.7636C250.828 41.8636 252.46 43.4769 253.707 45.6036C254.953 47.7303 255.577 50.3153 255.577 53.3586C255.577 56.3653 254.953 58.9503 253.707 61.1136C252.46 63.2403 250.828 64.8719 248.812 66.0086C246.795 67.1086 244.632 67.6586 242.322 67.6586ZM242.322 61.1136C243.972 61.1136 245.218 60.4169 246.062 59.0236C246.905 57.5936 247.327 55.7053 247.327 53.3586C247.327 50.9753 246.905 49.0869 246.062 47.6936C245.218 46.3003 243.972 45.6036 242.322 45.6036C240.635 45.6036 239.37 46.3003 238.527 47.6936C237.72 49.0869 237.317 50.9753 237.317 53.3586C237.317 55.7053 237.72 57.5936 238.527 59.0236C239.37 60.4169 240.635 61.1136 242.322 61.1136Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.078 77.1186V39.7186H205.678L206.228 42.4136H206.448C207.511 41.4603 208.703 40.6719 210.023 40.0486C211.38 39.3886 212.773 39.0586 214.203 39.0586C217.503 39.0586 220.106 40.3236 222.013 42.8536C223.92 45.3469 224.873 48.7019 224.873 52.9186C224.873 56.0353 224.323 58.6936 223.223 60.8936C222.123 63.0936 220.693 64.7803 218.933 65.9536C217.21 67.0903 215.358 67.6586 213.378 67.6586C212.205 67.6586 211.068 67.4203 209.968 66.9436C208.868 66.4303 207.841 65.7153 206.888 64.7986L207.163 69.1436V77.1186H199.078ZM211.508 61.0586C212.901 61.0586 214.093 60.4169 215.083 59.1336C216.073 57.8503 216.568 55.8153 216.568 53.0286C216.568 48.1153 214.991 45.6586 211.838 45.6586C210.261 45.6586 208.703 46.4836 207.163 48.1336V59.2986C207.896 59.9586 208.63 60.4169 209.363 60.6736C210.096 60.9303 210.811 61.0586 211.508 61.0586Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.122 67.6605C177.776 67.6605 175.429 67.2205 173.082 66.3405C170.772 65.4605 168.701 64.1771 166.867 62.4905L171.487 56.9355C172.771 58.0355 174.201 58.9338 175.777 59.6305C177.354 60.3271 178.876 60.6755 180.342 60.6755C182.029 60.6755 183.276 60.3638 184.082 59.7405C184.926 59.1171 185.347 58.2738 185.347 57.2105C185.347 56.0738 184.871 55.2488 183.917 54.7355C183.001 54.1855 181.754 53.5805 180.177 52.9205L175.502 50.9405C174.292 50.4271 173.137 49.7488 172.037 48.9055C170.937 48.0255 170.039 46.9438 169.342 45.6605C168.646 44.3771 168.297 42.8738 168.297 41.1505C168.297 39.1705 168.829 37.3738 169.892 35.7605C170.992 34.1471 172.496 32.8638 174.402 31.9105C176.346 30.9571 178.564 30.4805 181.057 30.4805C183.111 30.4805 185.164 30.8838 187.217 31.6905C189.271 32.4971 191.067 33.6705 192.607 35.2105L188.482 40.3255C187.309 39.4088 186.136 38.7121 184.962 38.2355C183.789 37.7221 182.487 37.4655 181.057 37.4655C179.664 37.4655 178.546 37.7588 177.702 38.3455C176.896 38.8955 176.492 39.6838 176.492 40.7105C176.492 41.8105 177.006 42.6355 178.032 43.1855C179.096 43.7355 180.397 44.3221 181.937 44.9455L186.557 46.8155C188.721 47.6955 190.444 48.9055 191.727 50.4455C193.011 51.9855 193.652 54.0205 193.652 56.5505C193.652 58.5305 193.121 60.3638 192.057 62.0505C190.994 63.7371 189.454 65.0938 187.437 66.1205C185.421 67.1471 182.982 67.6605 180.122 67.6605Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.858 77.6687C142.051 77.6687 141.336 77.6137 140.713 77.5037C140.126 77.3937 139.558 77.2654 139.008 77.1188L140.438 70.9587C140.695 70.9954 140.988 71.0504 141.318 71.1238C141.648 71.2338 141.96 71.2888 142.253 71.2888C143.61 71.2888 144.655 70.9587 145.388 70.2987C146.121 69.6387 146.671 68.7771 147.038 67.7138L147.423 66.2838L136.918 39.7188H145.058L148.963 51.4337C149.366 52.6804 149.733 53.9454 150.063 55.2288C150.393 56.5121 150.741 57.8321 151.108 59.1887H151.328C151.621 57.9054 151.915 56.6221 152.208 55.3388C152.538 54.0188 152.868 52.7171 153.198 51.4337L156.498 39.7188H164.253L154.793 67.2738C153.95 69.5471 153.015 71.4538 151.988 72.9938C150.961 74.5704 149.715 75.7437 148.248 76.5137C146.818 77.2837 145.021 77.6687 142.858 77.6687Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.73 67.0006V31.1406H120.05C122.69 31.1406 125.074 31.5073 127.2 32.2406C129.364 32.9373 131.087 34.129 132.37 35.8156C133.654 37.5023 134.295 39.794 134.295 42.6906C134.295 45.4773 133.654 47.769 132.37 49.5656C131.087 51.3623 129.382 52.7006 127.255 53.5806C125.129 54.424 122.8 54.8456 120.27 54.8456H115.815V67.0006H107.73ZM115.815 48.4106H119.775C124.175 48.4106 126.375 46.504 126.375 42.6906C126.375 40.8206 125.789 39.5006 124.615 38.7306C123.442 37.9606 121.755 37.5756 119.555 37.5756H115.815V48.4106Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7231fdc56aed9fb78a21a9bef3bcbb1.svg";
export { ForwardRef as ReactComponent };